<p>search-input works!</p>
